<script>
export default {
  name: 'SuiProp',
  props: {
    prop: {
      type: Object,
      default: () => ({})
    },
    tag: {
      type: String,
      required: true
    },
    tagRef: {
      type: String,
      default: ''
    },
    slots: {
      type: Object,
      default: () => ({})
    },
    events: {
      type: Object,
      default: () => ({})
    }
  },
  render(createElement) {
    let { prop, tag, tagRef, slots, events } = this
    return createElement(tag, {
      // 传递的属性，平铺展示
      attrs: { ...prop },
      // props: { ...prop },
      // 绑定的事件，进行传递
      on: { ...this.$listeners, ...events },
      // 内置的插槽，传递
      scopedSlots: {
        ...this.$scopedSlots,
        ...slots
      },
      ref: tagRef || tag.substr(4)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/other/SuiProp.vue